<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
       <b-card class="Reports">
            <b-form class="formBox"> 
                <b-form-group class="radioGroup" label="Rapor Tipi" label-for="type">
                    <b-form-radio-group
                        id="type"
                        v-model="type"
                        :options="types"
                        aria-describedby="live-feedback"></b-form-radio-group>
                </b-form-group>
                <b-form-group v-if="type == 1" class="inputGrp" label="Abone Aralığı" label-for="accountNoStrt">
                    <b-form-input id="accountNoStrt" v-model="beginAccount" />
                    <b-form-input id="accountNoEnd" v-model="endAccount" />
                </b-form-group>
                <b-form-group class="inputGrp" label="Tarih Aralığı" label-for="beginDate">
                    <Datetime id="beginDate" v-model="beginDate" />
                    <Datetime id="endDate" v-model="endDate" />
                </b-form-group>
                <b-form-group class="inputGrp" label="">
                    <div class="elements">
                        <b-form-checkbox  v-model="allSignal" >
                            <span v-if="allSignal"> Tüm Sinyal Grupları</span>
                            <span v-else> Belirli Sinyal Grupları</span>
                        </b-form-checkbox> 
                        <Multiselect v-model="addSignals" :show-labels="false" :options="signalGroups" v-if="!allSignal" :multiple="true" label="name" track-by="ID" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.name }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>  
                <b-form-group class="inputGrp" label="">
                    <div class="elements">
                        <b-form-checkbox  v-model="allNoSignal" >
                             <span v-if="allNoSignal"> Tüm Sinyal Grupları</span>
                            <span v-else> Belirli Sinyal Grupları Hariç</span>
                        </b-form-checkbox> 
                        <Multiselect v-model="removeSignals" :show-labels="false" :options="signalGroups" v-if="!allNoSignal" :multiple="true" label="name" track-by="ID" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.name }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group> 
                <b-form-group class="inputGrp" label="">
                    <div class="elements">
                        <b-form-checkbox  v-model="allCompany" >
                            <span v-if="allCompany"> Tüm Firmalar </span>
                            <span v-else> Belirli Firmalar</span>
                        </b-form-checkbox> 
                        <Multiselect v-model="company" :show-labels="false" :options="companies" :multiple="false" v-if="!allCompany" label="name" track-by="id" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.name }}</strong> 
                            </template>
                        </Multiselect>
                    
                    </div>
                </b-form-group>    
                <b-form-group class="inputGrp" label="" >
                    <div class="elements">
                        <b-form-checkbox  v-model="allCommunicate" > 
                            <span v-if="allCommunicate"> Tüm İletişim Türleri </span>
                            <span v-else> Belirli İletişim Türleri</span>
                        </b-form-checkbox> 
                        <Multiselect  v-model="communicate" :options="communicates" :multiple="false" v-if="!allCommunicate" :show-labels="false" label="name" track-by="id" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
                <b-form-group class="inputGrp" label="">
                    <div class="elements">
                        <b-form-checkbox  v-model="allResults" > 
                            <span v-if="allResults"> Tüm Değerlendirme Sonuçları </span>
                            <span v-else> Belirli Değerlendirme Sonuçları</span>
                        </b-form-checkbox> 
                        <Multiselect  v-model="result" :options="results" :multiple="false" v-if="!allResults" show-labels="false" label="description" track-by="id" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
            </b-form>
            <template v-slot:footer class="footer">
                <b-button variant="primary" @click="exportXlsx">Excel'e Aktar</b-button>
            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Modals from './modals/'
    import Multiselect from 'vue-multiselect'
    import { Datetime } from 'vue-datetime';
    import i18n from '@/plugins/i18n';
    import moment from 'moment'

    let breadCrumb = [
        { label: "Raporlar", url: "/Reports" },
        { label: "Sinyal Raporu", url: "/Reports/Signal" },
    ]

    export default {
        name: 'Reports',
        created: async function(){
            //  Receivers, Line Karts
             await this.$store.dispatch('company_get', {limit: 1000, offset: 0})
             await this.$store.dispatch("listEvaluationResults")
             await this.$store.dispatch("signal_group_list");

        },
        computed: {
            loading(){
                return this.$store.getters.getReportLoading
            },
            companies(){
                return this.$store.getters.getCompanies
            },
            results(){
                return this.$store.getters.getEvaluationResults;
            },
            reports(){
                return this.$store.getters.report.data
            },
            signalGroups() {
                return this.$store.getters.getSignalGroups;
            },
            
        },
        data:function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Reports",
                modalName: "",
                type: 0,
                result: null,
                company: null,
                communicate: null,
                accountType: 0,
                allCompany: true,
                allResults: true,
                allCommunicate: true,
                allSignal: true,
                allNoSignal: true,
                addSignals: [],
                removeSignals: [],
                beginDate: moment().subtract(1, 'months').format('YYYY-MM-DDTHH:mm:ssZ'),
                endDate: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                types: [
                    { text: 'Tüm Aboneler', value: 0 },
                    { text: 'Abone Aralığı', value: 1 },
                ],
                communicates: [
                    {id: 0, name:  i18n.t('account.com.gprs')},
                    {id: 1, name:  i18n.t('account.com.pstn')},
                    {id: 2, name:  i18n.t('account.com.ethernet')},
                ],
            }
        },
        components:{
            BreadCrumb, Modals, Multiselect, Datetime
        },
        methods:{
          
            exportXlsx: async function(){
                let data = {
                    "begin-date": this.beginDate,
                    "com-type": this.communicate ,
                    "company": this.company,
                    "end-date": this.endDate,
                    "ev-result": this.result,
                    "line-no": "",
                    "receiver-no": "",
                    responseType: 'arraybuffer'
                }
                if(this.type == 1){
                    data['begin-code'] = this.beginAccount
                    data['end-code'] = this.endAccount
                }
                if(!this.allSignal){
                    let selectedSignals = this.addSignals.map( item => item.ID )
                    data.signals = selectedSignals.join()
                }
                if(!this.allNoSignal){
                    let selectedSignals = this.removeSignals.map( item => item.ID )
                    data['without-signals'] = selectedSignals.join()
                }
                await this.$store.dispatch('getSignalReport', data)
                let url = window.URL.createObjectURL(new Blob([this.$store.getters.signalReport.data]))
                const link = document.createElement('a');
                 link.href = url;
                link.setAttribute('download', moment(this.beginDate).format('DD.MM.YYYY')+'-'+moment(this.endDate).format('DD.MM.YYYY')+' SinyalRaporu.xlsx');
                document.body.appendChild(link);
                link.click();
                
            },
        }
    }
</script>

<style lang="css" scoped> 
    @import "./styles/report.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Reports/Signal.vue